import React from 'react';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import BasicPopup from '../basic-popup';
import { useExpressionOfInterestPopups } from './hooks';

const ExpressionOfInterestPopup = () => {
  const {
    dialogData,
    error,
    loading,
    dialogOpen,
    isAfterEoiDeadline,
    handleDialogClose,
    handleAlreadySubmitted,
  } = useExpressionOfInterestPopups();

  return isAfterEoiDeadline ? (
    <BasicPopup
      id="after-eoi-deadline-notice"
      dataElementId={DataElementId.EOI_NOTICE_AFTER_DEADLINE_POPUP}
      dialogData={dialogData}
      dialogOpen={dialogOpen ?? false}
      loading={loading}
      cmsError={error}
      handleOnClose={handleDialogClose}
      primaryButton={{
        content: dialogData?.primaryButton?.text,
        route: dialogData?.primaryButton?.url,
        dataElementId: DataElementId.EOI_NOTICE_AFTER_DEADLINE_POPUP_PROCEED,
      }}
      secondaryButton={{
        content: dialogData?.secondaryButton?.text,
        onClick: handleDialogClose,
        dataElementId: DataElementId.EOI_NOTICE_AFTER_DEADLINE_POPUP_CLOSE,
      }}
    />
  ) : (
    <BasicPopup
      id="before-enrollment-notice"
      dataElementId={DataElementId.EOI_NOTICE_BEFORE_ENROLLMENT_POPUP}
      dialogData={dialogData}
      dialogOpen={dialogOpen ?? false}
      loading={loading}
      cmsError={error}
      handleOnClose={handleDialogClose}
      primaryButton={{
        content: dialogData?.primaryButton?.text,
        route: dialogData?.primaryButton?.url,
        dataElementId: DataElementId.EOI_NOTICE_BEFORE_ENROLLMENT_POPUP_PROCEED,
      }}
      secondaryButton={{
        dataElementId: DataElementId.EOI_NOTICE_BEFORE_ENROLLMENT_POPUP_SUBMIT,
        content: dialogData?.secondaryButton?.text,
        onClick: handleAlreadySubmitted,
      }}
    />
  );
};

export default ExpressionOfInterestPopup;
